import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import { DraggableModal } from 'components/flink-components';

const CSVImporter = ({handleImport, show, onClose, title}) => {
  const [data, setData] = useState([]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    if (file) {
      Papa.parse(file, {
        header: true, 
        skipEmptyLines: true,
        complete: (result) => {
          console.log("Parsed Result: ", result.data);
          setData(result.data);
        },
        error: (error) => {
          console.error("CSV parsing error:", error);
        }
      });
    }
  };

  useEffect(() => {
    if (data?.length)
      handleImport(data);
  }, [handleImport, data]);

  return (
    <DraggableModal show={show} onClose={onClose} title={title} withOverlay>
      <div>
        <input 
          type="file" 
          accept=".csv" 
          onChange={handleFileUpload} 
        />
      </div>
    </DraggableModal>
  );
};

export default CSVImporter;
